import { areaIndex } from "~/containers/LegacyDesigner/state/elements/areas"
import type { TransactionOperation } from "~/containers/LegacyDesigner/state/elements/transactions"

// Not `reset`: inside a Recoil transaction, a later `get` of a reset atom
// returns the DefaultValue sentinel rather than the atom's default.
export const resetAreaIndex: TransactionOperation = ({ set }) =>
  set(areaIndex, [])
